import React from 'react';
import SummaryCard from '../shared/SummaryCard';

const ImagesSection = ({ imagesData, onViewDetails }) => {
    if (!imagesData || !imagesData.images || imagesData.images.length === 0) {
        return null;
    }

    const { total_images, total_unique_images, images } = imagesData;

    return (
        <div style={{ marginBottom: '30px' }}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '15px'
            }}>
                <h4 style={{ color: '#e0e0e0', fontWeight: '600', margin: 0 }}>Images</h4>
                <button
                    onClick={onViewDetails}
                    style={{
                        backgroundColor: '#3a3a3a',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '4px',
                        padding: '8px 14px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        fontWeight: '600'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#4a4a4a'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#3a3a3a'}
                >
                    View image details
                </button>
            </div>
            <div style={{
                backgroundColor: '#2d2d2d',
                border: '1px solid #404040',
                borderRadius: '6px',
                padding: '20px'
            }}>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
                    gap: '15px'
                }}>
                    <SummaryCard label="Total Images" value={total_images ?? 0} />
                    <SummaryCard label="Unique Images" value={total_unique_images ?? images.length} />
                </div>
            </div>
        </div>
    );
};

export default ImagesSection;

